import { GlToken, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { flowTriggerEventTokens } from 'ee/ai/duo_agents_platform/utils';
export default {
    name: 'FlowTriggerEventTokens',
    components: {
        GlToken
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        timezoneData: {
            default: ()=>[]
        }
    },
    props: {
        flowTrigger: {
            type: Object,
            required: true
        }
    },
    computed: {
        tokens () {
            return flowTriggerEventTokens(this.flowTrigger, {
                timezoneData: this.timezoneData
            });
        }
    }
};
